import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface UserDataState {
  zipCode: string | null;
  income: string | null;
  householdSize: number | null;
  setZipCode: (zipCode: string) => void;
  setIncome: (income: string) => void;
  setHouseholdSize: (householdSize: number) => void;
  clearUserData: () => void;
}

export const useUserDataStore = create<UserDataState>()(
  persist(
    (set) => ({
      zipCode: null,
      income: null,
      householdSize: null,
      setZipCode: (zipCode) => set({ zipCode }),
      setIncome: (income) => set({ income }),
      setHouseholdSize: (householdSize) => set({ householdSize }),
      clearUserData: () => set({ zipCode: null, income: null, householdSize: null }),
    }),
    {
      name: 'user-data-storage',
    }
  )
);